module.exports = "/_next/static/images/listing-5bebcb21d1c16555047ca8d51b38a427.png";